module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@2x-e84e7d570c77c4aa2334a7f8057eeeb4.png";